// extracted by mini-css-extract-plugin
var _1 = "EntityTabEmailsMessageModal-modulebody__PLqEc";
export { _1 as "body" }
